import Swiper from 'swiper/bundle';

$(document).ready(() => {
    //console.log('heroSwiper script loaded');
    const $slider = jQuery('.hero__slider');
    if ($slider.length) {
        console.log('.hero__slider found');
        console.log('Number of slides:', $slider.find('.swiper-slide').length);
        if (typeof Swiper === 'undefined') {
            console.error('Swiper is not loaded!');
        } else {
            const swiper = new Swiper(".hero__slider", {
                loop: true,
                effect: "fade",
                fadeEffect: {
                    crossFade: true
                },
                speed: 1500, // transition duration in ms
                autoplay: {
                    delay: 4000, // 6 seconds per slide
                    disableOnInteraction: false // keeps autoplay after user interaction
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                },
            });
            console.log('Swiper instance:', swiper);
        }
    } else {
        //console.warn('.hero__slider not found');
    }
});